<template>

</template>

<script>
export default {
  name: "Day"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Day.vue